import type { Namespace } from '../../../types.js';

export const roles: Namespace = {
  'roles.owner': 'Владелец',
  'roles.admin': 'Администратор',
  'roles.member': 'Участник',
  'roles.viewer': 'Наблюдатель',
  'roles.guest': 'Гость',
};
